/** Row selected in a list, keyed by its slot: `?sel.<slotKey>=<rowId>`. Mirrors `t.<slotKey>`. */
export const SELECTION_PARAM_PREFIX = "sel.";

export const selectionParamName = (slotKey: string): string =>
  `${SELECTION_PARAM_PREFIX}${slotKey}`;

/** Slot key → row id for every `sel.` param with a value. */
export const selectionsFromSearch = (params: URLSearchParams): Record<string, string> => {
  const next: Record<string, string> = {};
  for (const [key, value] of params.entries()) {
    const id = value.trim();
    if (key.startsWith(SELECTION_PARAM_PREFIX) && id.length > 0) {
      next[key.slice(SELECTION_PARAM_PREFIX.length)] = id;
    }
  }

  return next;
};
